import React, { Component } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './style.scss'

class NotificationToast extends Component {
  showToast(content, options={}){
    toast(content,options);
  }
  render(){
    const { autoClose, draggable, position } = this.props;
    return(
      <ToastContainer
        position={position} 
        autoClose={autoClose}
        draggable={draggable}
        className='containerStyle'
        toastClassName='toastStyle'
      />
    );
  }
}

export default NotificationToast;


// WEBPACK FOOTER //
// ./src/components/UI/NotificationToast/index.js